import { Component, Input } from '@angular/core';
import { PersonalInfoFieldTypeEnum } from "@modules/api/personal-info-field-type-enum.generated";
import { PIIQuestionFormGroup } from '@modules/login-shared/types/pii-question-form-group.type';

@Component({
    selector: 'app-login-enter-pii-answer',
    templateUrl: './login-enter-pii-answer.component.html',
    styleUrls: ['./login-enter-pii-answer.component.scss']
})
export class LoginEnterPIIAnswerComponent {
    @Input()
    public formGroup!: PIIQuestionFormGroup;

    public isInputTypeDateTime(formGroup: PIIQuestionFormGroup): boolean {
        return formGroup.controls.piiField.value.personalInfoFieldType == PersonalInfoFieldTypeEnum.DateTime;
    }

    public isInputTypeText(formGroup: PIIQuestionFormGroup): boolean {
       return formGroup.controls.piiField.value.personalInfoFieldType == PersonalInfoFieldTypeEnum.Text;
    }

    public isInputTypeMaskedText(formGroup: PIIQuestionFormGroup): boolean {
        return formGroup.controls.piiField.value.personalInfoFieldType == PersonalInfoFieldTypeEnum.MaskedText;
    }

    public isInputTypePhoneNumber(formGroup: PIIQuestionFormGroup): boolean {
        return formGroup.controls.piiField.value.personalInfoFieldType == PersonalInfoFieldTypeEnum.PhoneNumber;
    }
}